/**
 * Created by jonas on 2021-02-02.
 */
import {StateMatrix, StateMatrixCoordinate} from "../utils/StateMatrix";
import {BS2SymbolStates} from "../reels/BS2Symbol";
import {gsap} from "gsap";
import {SimpleReelModelSymbolData} from "../../core/reel/simplereel/SimpleReelModel";

export function isBS2InitData(value: any): value is BS2InitData {
    return value.betLines !== undefined;
}

export function isBS2GameData(value: any): value is BS2GameData {
    return value.betWayWins !== undefined;
}

export interface SymbolValues {
    [symbolName: string]: {
        3: number, 4: number, 5: number
    }
}

export enum SpinMode {
    SPIN,
    AVALANCHE
}

export interface PossibleWinLineData {
    matrix: StateMatrix<boolean>,
    reels: boolean[]
}

export interface PossibleWinData {
    lines: PossibleWinLineData[],
    combinedMatrix: StateMatrix<boolean>,
    combinedReels: boolean[]
}


export interface ScatterData {
    name: string;
    indexPosition: StateMatrixCoordinate;
    transformInto: string
}

export enum WildSpinAnimName {
    IDLE_CANDLES = "idle",
    IDLE_EYES_FIRE_1="idle_chains_Level1",
    IDLE_EYES_FIRE_LOOP_1="idle_chains_Loop_Level1",
    IDLE_EYES_FIRE_2="idle_chains_Level2",
    IDLE_EYES_FIRE_LOOP_2="idle_chains_Loop_Level2",
    IDLE_EYES_FIRE_3="idle_chains_Level3",
    IDLE_EYES_FIRE_LOOP_3="idle_chains_Loop_Level3",
    LAND = "land",
    WIN = "win",
    WIN_HIGHLIGHT = "win_highlight",
    IDLE_ALL="idle_all",
}

export interface replaceWithNewSymbolDataType {
    oldSymbol: SimpleReelModelSymbolData,
    newSymbol: SimpleReelModelSymbolData
}

export interface BS2Data {
    mode: string;
    nextMode: string;
    reels: string[][];
    accumulatedRoundWin: number;
    freespinsLeft: number;
    wasFeatureBuy: boolean;
    currentLevel: number;
    currentMultiplier: number;
    scatterReels: boolean[];
    totalScatterRevealed: number;
    symbolSizes: number [][];
    collectedSymbols: number;
    nextLevel: number;
    reelsAfterCollapse: string[][];
    symbolSizesAfterCollapse: number[][];
    upgradeLevel: boolean;
    totalCollectedSymbols: number;
    enhancedBet: boolean;
    splitDirections:number[][];
    splitDirectionsAfterCollapse:number[][];
}

export interface BS2InitData extends BS2Data {
    symbolValues: SymbolValues;
    isRestoreState: boolean;
    reelsNextSpin: string;
    "featureBuyTimesBetValue": [
        {
            "name": "FREESPIN",
            "type": "FREESPIN",
            "price": 66
        },
        {
            "name": "FREESPIN_LEVEL5",
            "type": "FREESPIN",
            "price": 55
        },
        {
            "name": "FREESPIN_LEVEL3",
            "type": "FREESPIN",
            "price": 166
        },
        {
            "name": "SUPER_FREESPIN",
            "type": "FREESPIN",
            "price": 500
        }
    ],
    gameLevels: number[];
}


export interface BS2GameData extends BS2Data {
    evaluatedArea: string[][];
    betWayWins: BetWayWin[];
    thisSpinWinning: number;
    totalSpinWinnings: number;
    playedBetValue: number;
    isRandomLevel?: boolean;
    addedNumberOfFreespinsThisSpin: number;
    brokeTheBank: boolean;
    initialAreaSize: number [];
    collapsedReel: any;
    previousReels: string[][];
    numberOfFreespinsPlayed: number;
    featureName:string;
}

export interface XSplitData {
    direction: XSplitDirection,
    splitSymCoordinate: StateMatrixCoordinate,
    symbolName: string
}

export enum XSplitDirection {
    HORIZONTAL = "D",
    VERTICAL = "G"
}

export interface BetWayWin {
    amount: number;
    length: number;
    mode: string;
    multipliedAmount: number;
    multiplier: number;
    numberOfCombinations: number;
    symbol: string;
    reelWinPositions: boolean[][];
    reelWinLvlPositions: number[][];
    winLvl: number;
}

export interface WinLineData {
    betWayWin: BetWayWin,
    coordinates: StateMatrixCoordinate[],
    matrix: StateMatrix<boolean>
}

export interface WinData {
    lines: WinLineData[],
    matrix: StateMatrix<BS2SymbolStates>
    winWays: number;
    winRatio: number;
    accumulatedWinRatio: number;
    accumulatedWin: number;
}

export interface PopAndMoveData {
    moveAnimation: gsap.core.Timeline,
    symbolData: SimpleReelModelSymbolData
}